/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import styled from 'styled-components';
import { constants } from '../../../constants';
import {
  SYS_SPACE_RELATIVE_2_XS,
  SYS_SPACE_RELATIVE_LG,
  SYS_SPACE_RELATIVE_MD,
} from '@oneaudi/unified-web-common';

interface TextBlockProps {
  theme: boolean;
  width?: number;
  isAlpha?: boolean;
}

export interface UnifiedTheme {
  theme: {
    sys: {
      color: {
        canvas: {
          [200]?: string;
          default?: string;
        };
      };
    };
  };
}

const device = {
  desktop: `(min-width: ${constants.displaySizes.desktop})`,
  largeDesktop: `(min-width: ${constants.displaySizes.largeDesktop})`,
  mobile: `(min-width: ${constants.displaySizes.mobile})`,
  smallDesktop: `(min-width: ${constants.displaySizes.smallDesktop})`,
  tablet: `(min-width: ${constants.displaySizes.tablet})`,
  smallTablet: `(max-width: ${constants.displaySizes.tablet})`,
};

const maxWidthWithPagination = (width: number | undefined, gap: number) =>
  width === undefined ? '100%' : `calc(100% - ${width}px - ${gap}px)`;

export const TextBlock = styled.div<TextBlockProps>`
  background-color: ${(props) =>
    props.isAlpha ? 'transparent' : props.theme.sys.color.canvas.default};
  display: flex;
  flex-flow: column nowrap;
  height: auto;
  padding-bottom: 24px;
  position: relative;

  @media ${device.tablet} {
    margin-top: 0px;
    min-height: 1px;
    height: auto;
    padding: ${(props) =>
      props.isAlpha ? `${SYS_SPACE_RELATIVE_LG} 0px ${SYS_SPACE_RELATIVE_MD}` : `16px 0px 36px`};
  }

  @media ${device.smallDesktop} {
    height: auto;
    padding: ${(props) =>
      props.isAlpha ? `${SYS_SPACE_RELATIVE_LG} 0px ${SYS_SPACE_RELATIVE_MD}` : ` 16px 0px 24px`};
  }

  @media ${device.desktop} {
    height: auto;
  }

  @media ${device.largeDesktop} {
    height: auto;
  }
`;

export const TitleTextBlock = styled.div<TextBlockProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${(props) => (props.isAlpha ? `0px 0px ${SYS_SPACE_RELATIVE_MD}` : `16px 0px 25px`)};

  .alpha-title {
    padding-bottom: ${SYS_SPACE_RELATIVE_2_XS};
  }
  sup {
    font-feature-settings: normal !important;
  }

  @media ${device.tablet} {
    max-width: ${(props) => maxWidthWithPagination(props.width, 17)};
  }

  @media ${device.smallDesktop} {
    max-width: ${(props) => maxWidthWithPagination(props.width, 48)};
  }

  @media ${device.desktop} {
    max-width: ${(props) => maxWidthWithPagination(props.width, 97)};
  }

  @media ${device.largeDesktop} {
    max-width: ${(props) => maxWidthWithPagination(props.width, 60)};
  }
`;

export const CTAContainer = styled.div`
  > a::before {
    content: unset;
  }
  @media ${device.mobile} {
    button {
      margin: 0;
    }
  }

  @media ${device.tablet} {
    width: 344px;
  }

  @media ${device.desktop} {
    width: 270px;
  }
  @media ${device.smallDesktop} {
    width: 270px;
  }
  @media ${device.smallDesktop} {
    width: 270px;
  }

  @media ${device.largeDesktop} {
    width: 270px;
  }

  button {
    margin: 0;
  }
`;
